/**
 * Zentrale IT-SEO-Defaults (bigfollow.it — Storefront Italien).
 * Spiegelt window.__BF_IT_SEO__ aus index.html — beide MÜSSEN
 * übereinstimmen, damit der erste React-Render byte-identisch zum
 * Roh-HTML ist. Wird nur konsumiert, wenn useStorefront().storefront === 'it'.
 *
 * CH bleibt unberührt: kein Import in CH-Renderpfaden ohne Ternary.
 * Zahlungen: PayPal, Kreditkarte (Visa/Mastercard), Klarna — KEIN TWINT.
 */
export const IT_SEO_DEFAULTS = {
  // `title` wird als Prop an <SEOHead> übergeben; SEOHead hängt " | BigFollow" an.
  // Endgültiger Titel: "Comprare follower — Instagram & TikTok Italia | BigFollow"
  title: 'Comprare follower — Instagram & TikTok Italia',
  description:
    'Follower, like e views per Instagram e TikTok. Pagamento con PayPal, carta di credito o Klarna. Consegna rapida in Italia.',
  heroTitle: 'Comprare follower — Instagram & TikTok',
  heroSubtitle: 'Fai crescere Instagram e TikTok velocemente',
  heroText:
    'Follower reali di qualità, like, views e commenti — consegnati in pochi minuti, pagamento sicuro con PayPal, carta di credito o Klarna. Semplice e affidabile per l\u2019Italia.',
} as const;